import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingV2 from "./pages/LandingV2";
import StyleGuide from "./pages/StyleGuide";
import StyleGuideOld from "./pages/StyleGuideOld";
import NotFound from "./pages/NotFound";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import PE from "./pages/PE";
import Assessment from "./pages/Assessment";
import CaseStudy from "./pages/CaseStudy";
import AI from "./pages/AI";
import WhatIsAFractionalCPO from "./pages/WhatIsAFractionalCPO";
import FractionalCPOvsCMO from "./pages/FractionalCPOvsCMO";
import FractionalCPOvsCTO from "./pages/FractionalCPOvsCTO";
import FractionalCPOvsCOO from "./pages/FractionalCPOvsCOO";
import FractionalCPOvsConsultant from "./pages/FractionalCPOvsConsultant";
import HowFractionalExecutivesWorkTogether from "./pages/HowFractionalExecutivesWorkTogether";
import ProductLedGrowth from "./pages/ProductLedGrowth";
import FractionalCPOCost from "./pages/FractionalCPOCost";
import About from "./pages/About";

import { useEffect } from "react";
import ScrollToTop from "./components/ScrollToTop";
import PostHogPageview from "./components/PostHogPageview";
import CollectBeacon from "./components/CollectBeacon";
import { initConsent } from "./utils/consent";

const queryClient = new QueryClient();

const ConsentInit = () => {
  useEffect(() => { initConsent(); }, []);
  return null;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ConsentInit />
        <ScrollToTop />
        <PostHogPageview />
        <CollectBeacon />
        <Routes>
          <Route path="/" element={<LandingV2 />} />
          <Route path="/style-guide" element={<StyleGuide />} />
          <Route path="/style-guide-old" element={<StyleGuideOld />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/pe" element={<PE />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/case-study" element={<CaseStudy />} />
          <Route path="/ai" element={<AI />} />
          <Route path="/what-is-a-fractional-cpo" element={<WhatIsAFractionalCPO />} />
          <Route path="/fractional-cpo-vs-cmo" element={<FractionalCPOvsCMO />} />
          <Route path="/fractional-cpo-vs-cto" element={<FractionalCPOvsCTO />} />
          <Route path="/fractional-cpo-vs-coo" element={<FractionalCPOvsCOO />} />
          <Route path="/fractional-cpo-vs-consultant" element={<FractionalCPOvsConsultant />} />
          <Route path="/how-fractional-executives-work-together" element={<HowFractionalExecutivesWorkTogether />} />
          <Route path="/product-led-growth" element={<ProductLedGrowth />} />
          <Route path="/fractional-cpo-cost" element={<FractionalCPOCost />} />
          <Route path="/about" element={<About />} />

          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
